import { notyf } from '@modules';
import { pubsub, cart } from '@services';
import { d as debounce } from './debounce-CFN_LA0O.js';

class CartItem extends HTMLElement {
  #unsubscriber;
  #lineItemIndex = this.dataset.lineItemIndex;
  #loadingOverlay = this.querySelector('.loading-overlay');

  connectedCallback() {
    this.#unsubscriber = pubsub.subscribe('quantity:change', ({ line, quantity }) => {
      this.#handleQuantityChange(line, quantity);
    });
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * @description Handle the quantity change event
   * @param {number} line - The line item index
   * @param {number} quantity - The quantity
   */
  #handleQuantityChange = debounce(async (line, quantity) => {
    if (line !== this.#lineItemIndex) return;

    this.#handleLoading(true);

    try {
      await cart.change({
        line: this.#lineItemIndex,
        quantity,
      });
    } catch (error) {
      notyf.error(error.message);
    } finally {
      this.#handleLoading(false);
    }
  }, 300);

  /**
   * @description Handle the loading overlay
   * @param {boolean} loading - The loading state
   */
  #handleLoading(loading) {
    this.#loadingOverlay.ariaHidden = !loading;
  }
}

customElements.define('line-item', CartItem);
